import { render } from "./CalendarNavIcon.vue?vue&type=template&id=79d816db"
import script from "./CalendarNavIcon.vue?vue&type=script&lang=js"
export * from "./CalendarNavIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__